import 'normalize.css/normalize.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-image-lightbox/style.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import * as serviceWorker from './serviceWorker';
import { apiUrl, authApiUrl } from './config';
import apiService from './services/api';
import store from './store';
import theme from './theme';
import RouteScrollToTop from './utils/RouteScrollToTop';
import App from './pages/App';
import GlobalStyle from './globalStyles';

global.api = apiService.create({ defaultUrl: apiUrl });
global.authApi = apiService.create({ defaultUrl: authApiUrl });

ReactDOM.render(
  <Provider store={store}>
    <Router basename="/">
      <RouteScrollToTop>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </RouteScrollToTop>
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
